export default __webpack_public_path__ + "static/media/ico_cattle.2a6e118c.png";